import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../utils/routes';
import StyledButton from '../Common/StyledButton';

const Icon = styled.img`
  height: 72px;
  width: 72px;
`;

function CoachOnboardingSuccessBlock() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBackToLogin = () => {
    navigate(LOGIN_ROUTE);
  };

  return (
    <>
      <Icon src="/assets/icons/confetti.svg" />
      <Box display="flex" flexDirection="column" gap="16px">
        <Typography variant="title2Bold" textAlign="center" color="primary">
          {t('coachOnboarding.congratulations')}
        </Typography>
        <Typography variant="bodyRegular" textAlign="center" color="primary" fontWeight={500}>
          {t('coachOnboarding.accountCreatedDesc')}
        </Typography>
      </Box>
      <StyledButton onClick={goBackToLogin} endIcon>
        {t('forgetPassword.goBackToLogin')}
      </StyledButton>
    </>
  );
}

export default CoachOnboardingSuccessBlock;
